import { defineMessages } from 'react-intl';

export const i18n: {
	space: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterSpacePlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterLabelSelected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterLabelUnselected: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluenceFilterSpaceIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	space: {
		id: 'search-page.filters.names.space',
		defaultMessage: 'Space',
		description:
			'Label shown on the Confluence space filter dropdown button in the Quick Find dialog, allowing users to narrow search results by a specific Confluence space.',
	},
	confluenceFilterSpacePlaceholder: {
		id: 'search-page.confluence.filter.space.placeholder',
		defaultMessage: 'Find spaces',
		description: 'Placeholder for space filter search input',
	},
	confluenceFilterLabelSelected: {
		id: 'search-page.confluence.filter.label.selected',
		defaultMessage: 'Selected',
		description:
			'Group heading shown in the Confluence space filter dropdown in Quick Find to separate already-selected spaces from suggested ones.',
	},
	confluenceFilterLabelUnselected: {
		id: 'search-page.confluence.filter.label.unselected',
		defaultMessage: 'Suggested',
		description:
			'Group heading shown in the Confluence space filter dropdown in Quick Find to label spaces that are suggested but not yet selected.',
	},
	confluenceFilterSpaceIcon: {
		id: 'search-page.confluence.filter.space.icon',
		defaultMessage: 'Space Icon',
		description:
			'Accessible label for the space icon shown next to each space option in the Confluence space filter dropdown in the Quick Find dialog.',
	},
});
